import {LogoGlobalSecView} from '../view/vodin_logo_view';

import {connect} from "react-redux";


const LogoGlobalSec=connect()(LogoGlobalSecView);
export default LogoGlobalSec;
